import { Treatment, CompositeOperation } from '../treat-image.directive'

export class WaterMarkTreatment implements Treatment {
  options: {
    image: HTMLImageElement// | HTMLCanvasElement | HTMLVideoElement | ImageBitmap
    alpha?: number
    method?: CompositeOperation
    align?: string
    height?: number
    width?: number
    dest?: {
      height?: number
      width?: number
      x: number
      y: number
    },
    src?: {
      height: number
      width: number
      x: number
      y: number
    },
  } = {
    image: null
  };

  treat (image: HTMLImageElement, context: CanvasRenderingContext2D): ImageData {
    const options = this.options;
    context.drawImage(image, 0, 0, image.width, image.height);

    if (options.image) {

      if (options.method) {
        context.globalCompositeOperation = options.method;
      } else {
        context.globalCompositeOperation = 'normal';
      }

      if (options.alpha) {
        context.globalAlpha = options.alpha;
      } else {
        context.globalAlpha = 1;
      }

      if (options.width) {
        options.image.width = options.width;
      }
      if (options.height) {
        options.image.height = options.height;
      }

      if (!options.dest) {
        options.dest = {
          height: options.image.height,
          width: options.image.width,
          x: 0,
          y: 0
        };
      }

      switch (options.align) {
        case 'center':
          if (!options.dest) {
            options.dest = { x: 0, y: 0 };
          }
          options.dest.x = (image.width - options.image.width) / 2;
          options.dest.y = (image.height - options.image.height) / 2;
      }

      if (options.src) {
        context.drawImage(
          options.image,
          options.dest ? options.dest.x : 0,
          options.dest ? options.dest.y : 0,
          options.dest ? options.dest.width : image.width,
          options.dest ? options.dest.height : image.height,
          options.src ? options.src.x : 0,
          options.src ? options.src.y : 0,
          options.src ? options.src.width : options.image.width,
          options.src ? options.src.height : options.image.height,
        );
      } else {
        if (options.dest.width) {
          context.drawImage(
            options.image,
            options.dest ? options.dest.x : 0,
            options.dest ? options.dest.y : 0,
            options.dest ? options.dest.width : image.width,
            options.dest ? options.dest.height : image.height
          );
        } else {
          context.drawImage(
            options.image,
            options.dest ? options.dest.x : 0,
            options.dest ? options.dest.y : 0
          );
        }
      }
    }
    return context.getImageData( 0, 0, image.width, image.height );
  }
}
